module.exports = __webpack_public_path__ + "files/09721579c8e015e85500e6664fb0f2ba.png";